import { runDemo } from "../shared/demoRunner";
import { createTunnelScene } from "./scene";

runDemo({ createScene: createTunnelScene });
